// Function to get asset description
export const getAssetDescription = (symbol: string): string => {
  const descriptions: { [key: string]: string } = {
    'EURUSD': 'Euro/Dollar',
    'GBPUSD': 'Pound/Dollar',
    'USDJPY': 'Dollar/Yen',
    'AUDUSD': 'Aussie/Dollar',
    'USDCHF': 'Dollar/Swiss Franc',
    'USDCAD': 'Dollar/Canadian Dollar',
    'NZDUSD': 'New Zealand Dollar/Dollar',
    'EURGBP': 'Euro/Pound',
    'EURJPY': 'Euro/Yen',
    'GBPJPY': 'Pound/Yen',
    'BTCUSD': 'Bitcoin',
    'BTCUSDT': 'Bitcoin',
    'ETHUSD': 'Ethereum',
    'ETHUSDT': 'Ethereum',
    'SOLUSDT': 'Solana',
    'ADAUSDT': 'Cardano',
    'DOTUSDT': 'Polkadot',
    'TAOUSDT': 'Bittensor',
    'LINKUSDT': 'Chainlink',
    'LTCUSDT': 'Litecoin',
    'XRPUSDT': 'Ripple',
    'GOLD': 'Gold',
    'OIL': 'Crude Oil',
    'SPX': 'S&P 500'
  };
  return descriptions[symbol] || symbol;
};
